import React, { useEffect, useRef } from 'react';
import './FadeInEffect.css';

const FadeInSection = ({ children, delay = 0, threshold = 0.1 }) => {
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: threshold
    };

    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add a small delay if specified
          if (delay > 0) {
            setTimeout(() => {
              entry.target.classList.add('at-fade-in-visible');
            }, delay);
          } else {
            entry.target.classList.add('at-fade-in-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      observer.disconnect();
    };
  }, [delay, threshold]);

  return (
    <div ref={sectionRef} className="at-fade-in-effect at-fade-in">
      {children}
    </div>
  );
};

export default FadeInSection;